import React from 'react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from '../SectionHeading';
import { controlCenter } from '../../data/content';
export function ControlCenter() {
  return <section className="w-full bg-navy-900 py-14 sm:py-20" data-id="element-127" data-mp="230qkni97veje">
      <div className="mx-auto w-full max-w-5xl px-4" data-id="element-128" data-mp="22ycp78amk0bb">
        <SectionHeading tone="light" eyebrow="⚡ The Aligner Control Center™" title="Your quick-access clinical toolkit" subtitle="In addition to the 6 volumes, you’ll receive a complete collection of practical tools designed to help you navigate the system faster." data-id="element-129" data-mp="27yrzts3iutpl" />

        <ul className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-130" data-mp="1k2wav209kyzy">
          {controlCenter.map(tool => <li key={tool.title} className="flex h-full flex-col rounded-2xl border border-white/10 bg-white/[0.06] p-5" data-id="element-131" data-mp="1p2s6odyt5k4f">
              <span className="text-2xl" aria-hidden="true" data-id="element-132" data-mp="3jdnlvz4hzxg6">
                {tool.emoji}
              </span>
              <h3 className="mt-3 font-display text-base font-black uppercase tracking-tight text-white sm:text-lg" data-id="element-133" data-mp="3rjg4p197face">
                {tool.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-navy-100" data-id="element-134" data-mp="48gftssb1nyu">
                {tool.text}
              </p>
            </li>)}
        </ul>

        <div className="mx-auto mt-12 max-w-3xl rounded-3xl bg-white/[0.06] p-6 text-center sm:p-8" data-id="element-135" data-mp="8g0m5xdt8qq">
          <h3 className="font-display text-xl font-black uppercase leading-tight text-white sm:text-2xl" data-id="element-136" data-mp="38nzth3u54p59">
            This is not another aligner ebook.
            <br data-id="element-137" data-mp="3hnw8seun4bnn" />
            <span className="text-sky-400" data-id="element-138" data-mp="3hoeee2370288">
              It’s a system for organizing your workflow.
            </span>
          </h3>
          <p className="mt-4 text-base leading-relaxed text-navy-100" data-id="element-139" data-mp="wwm24jz0bl0s">
            You don’t need more information scattered across dozens of
            resources. You need a way to organize, review, and apply the
            information you already have.
          </p>
          <p className="mt-4 font-display text-sm font-black uppercase tracking-wide text-sky-400 sm:text-base" data-id="element-140" data-mp="3lp7rqlt4tsla">
            Frameworks + Checklists + Protocols + Trackers + Review tools
          </p>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-141" data-mp="3uo3126rh3ist">
          <CTAButton label="I want the complete system" data-id="element-142" data-mp="3itdsmuv5imw" />
        </div>
      </div>
    </section>;
}